<template>
  <el-dropdown class='international' trigger="click" @command="handleSetLanguage">
    <div>
      <svg-icon class-name='international-icon' icon-class="language"/>
      <a v-show="langType == true? true:false" class="title-language">Language</a>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">中文(简体)</el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item>
      <el-dropdown-item :disabled="language==='zh_ft'" command="zh_ft">中文(繁體)</el-dropdown-item>
      <el-dropdown-item :disabled="language==='th'" command="th">แบบไทย</el-dropdown-item>
      <el-dropdown-item :disabled="language==='vi'" command="vi">Tiếng Việt</el-dropdown-item>
      <!-- <el-dropdown-item command="ko" v-if="false" :disabled="language==='en'">한국어</el-dropdown-item>-->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    langType: {//是否显示复选框
      type: Boolean,
      default: true
    },
  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      this.$message({
        message: 'switch language success',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped>
.international-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -5px !important;
}

.title-language {
  font-size: 16px;
  font-family: inter;
  color: rgba(64, 158, 255, 1);
  line-height: 20px;
  text-decoration: underline;
}
</style>





// WEBPACK FOOTER //
// src/components/LangSelect/index.vue